import {jpBasePath} from "./_base";

export const jpPathLogin = jpBasePath.appendPathSegment("/login");